import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const LocalInventory = ({ isLocalInventoryEnabled }) => {
  const i18n = useContext(I18nContext);
  const localInventoryText = isLocalInventoryEnabled ? i18n.getString(_TL_('Enabled')) : i18n.getString(_TL_('Not enabled'));

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Local inventory') }}>
      <Text>{localInventoryText}</Text>
    </PropertyRow>
  );
};

LocalInventory.propTypes = {
  isLocalInventoryEnabled: PropTypes.bool,
};

LocalInventory.defaultProps = {
  isLocalInventoryEnabled: false,
};
